var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstTimeLoginStep"},[_c('h1',[_vm._v(_vm._s(_vm.$t("login.hello"))+" "+_vm._s(_vm.currentUser.fullName)+"!")]),_c('h3',[_vm._v(_vm._s(_vm.$t("login.intro1"))+".")]),_c('p',[_vm._v(_vm._s(_vm.$t("login.intro2"))+".")]),_c('b-btn',{attrs:{"variant":"outline-primary"},on:{"click":_vm.nextStep}},[_vm._v("Start")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }